import React, { useEffect, useState } from 'react';
import { Drawer, Table, Tag, Typography } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import AxiosUtils from 'utils/axios-utils';
import { API } from 'service/api-route';
import { VoteScoreLog, formatScore } from './types';

interface Props {
  open: boolean;
  voteId: number | string;
  onClose: () => void;
}

const actionTag = (log: VoteScoreLog) => {
  if (log.action === 'RESET') return <Tag color="volcano">Reset</Tag>;
  if (log.action === 'REMOVE') return <Tag color="default">Loại</Tag>;
  return log.delta >= 0 ? <Tag color="green">Cộng</Tag> : <Tag color="red">Trừ</Tag>;
};

/** Nhật ký cộng/trừ, reset, loại khỏi danh sách (vote_score_logs) — chỉ xem. */
const ScoreLogsDrawer = ({ open, voteId, onClose }: Props) => {
  const [loading, setLoading] = useState(false);
  const [logs, setLogs] = useState<VoteScoreLog[]>([]);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    AxiosUtils.get(API.voteAdminLogs(voteId))
      .then((res: any) => setLogs(res?.data || []))
      .catch(() => setLogs([]))
      .finally(() => setLoading(false));
  }, [open, voteId]);

  const columns: ColumnsType<VoteScoreLog> = [
    {
      title: 'Thời gian',
      key: 'createdAt',
      width: 120,
      render: (_, r) => (
        <span style={{ whiteSpace: 'nowrap' }}>{moment(r.createdAt).format('DD/MM HH:mm')}</span>
      ),
    },
    { title: 'Thao tác', key: 'action', width: 80, render: (_, r) => actionTag(r) },
    {
      title: 'Người tham gia',
      key: 'candidate',
      render: (_, r) =>
        r.candidate ? (
          r.candidate.nickName || r.candidate.username
        ) : (
          <Typography.Text type="secondary">Cả sự kiện</Typography.Text>
        ),
    },
    {
      title: 'Điểm',
      key: 'score',
      width: 150,
      render: (_, r) =>
        r.scoreBefore === null ? (
          '—'
        ) : (
          <span style={{ whiteSpace: 'nowrap' }}>
            {formatScore(r.scoreBefore)} →{' '}
            {r.scoreAfter === null ? 'loại' : formatScore(r.scoreAfter)}
          </span>
        ),
    },
    {
      title: 'Lý do · người làm',
      key: 'reason',
      render: (_, r) => (
        <div>
          <div>
            {r.reason || <Typography.Text type="secondary">Không ghi lý do</Typography.Text>}
          </div>
          <Typography.Text type="secondary" style={{ fontSize: 12 }}>
            {r.actorName || 'Không rõ'}
          </Typography.Text>
        </div>
      ),
    },
  ];

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Lịch sử điều chỉnh điểm"
      width={760}
      destroyOnHidden
    >
      <Table
        size="small"
        rowKey="id"
        columns={columns}
        dataSource={logs}
        loading={loading}
        pagination={{ pageSize: 20, hideOnSinglePage: true }}
        locale={{ emptyText: 'Chưa có điều chỉnh nào' }}
      />
    </Drawer>
  );
};

export default ScoreLogsDrawer;
